module.exports = __webpack_public_path__ + "img/jp.7cec236c.png";